import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { TopPerformer, formatCurrency } from '../utils/executiveMetrics';
type TopPerformersChartProps = {
  data: TopPerformer[];
};
export function TopPerformersChart({
  data
}: TopPerformersChartProps) {
  const CustomTooltip = ({
    active,
    payload,
    label
  }: any) => {
    if (active && payload && payload.length) {
      const direct = payload[0]?.value || 0;
      const indirect = payload[1]?.value || 0;
      return <div className="bg-white px-4 py-3 shadow-lg rounded-lg border border-gray-200" data-id="element-213">
          <p className="font-semibold text-gray-900 mb-2" data-id="element-214">{label}</p>
          <div className="space-y-1" data-id="element-215">
            <div className="flex items-center gap-2" data-id="element-216">
              <div className="w-3 h-3 rounded bg-blue-500" data-id="element-217" />
              <span className="text-sm text-gray-600" data-id="element-218">
                Direct: {formatCurrency(direct)}
              </span>
            </div>
            <div className="flex items-center gap-2" data-id="element-219">
              <div className="w-3 h-3 rounded bg-purple-500" data-id="element-220" />
              <span className="text-sm text-gray-600" data-id="element-221">
                Indirect: {formatCurrency(indirect)}
              </span>
            </div>
            <div className="pt-1 border-t border-gray-100 mt-1" data-id="element-222">
              <span className="text-sm font-semibold text-gray-900" data-id="element-223">
                Total: {formatCurrency(direct + indirect)}
              </span>
            </div>
          </div>
        </div>;
    }
    return null;
  };
  return <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-200" data-id="element-224">
      <div className="mb-6" data-id="element-225">
        <h3 className="text-lg font-semibold text-gray-900" data-id="element-226">Top Performers</h3>
        <p className="text-sm text-gray-500 mt-1" data-id="element-227">
          Direct vs indirect funding impact by top referrers
        </p>
      </div>

      <div className="h-[300px]" data-id="element-228">
        <ResponsiveContainer width="100%" height="100%" data-id="element-229">
          <BarChart data={data} layout="vertical" margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5
        }} data-id="element-230">
            <CartesianGrid strokeDasharray="3 3" horizontal={true} vertical={false} data-id="element-231" />
            <XAxis type="number" tickFormatter={value => `$${value >= 1000 ? `${(value / 1000).toFixed(1)}M` : `${value}K`}`} tick={{
            fontSize: 12,
            fill: '#6b7280'
          }} data-id="element-232" />
            <YAxis type="category" dataKey="name" tick={{
            fontSize: 12,
            fill: '#374151',
            fontWeight: 500
          }} width={70} data-id="element-233" />
            <Tooltip content={<CustomTooltip data-id="element-235" />} data-id="element-234" />
            <Legend wrapperStyle={{
            paddingTop: '20px'
          }} formatter={value => <span className="text-sm text-gray-600" data-id="element-237">{value}</span>} data-id="element-236" />
            <Bar dataKey="directFundings" name="Direct Fundings" fill="#3b82f6" radius={[0, 4, 4, 0]} stackId="stack" data-id="element-238" />
            <Bar dataKey="indirectFundings" name="Indirect Fundings" fill="#8b5cf6" radius={[0, 4, 4, 0]} stackId="stack" data-id="element-239" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>;
}